const environment = process.env.REACT_APP_ENVIRONMENT ? `_${process.env.REACT_APP_ENVIRONMENT}` : '';

export const languages = [
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' },
]

export const storageOptions = [
  { label: 'Trato Storage', value: 'trato' },
  { label: 'Dropbox', value: 'dropbox' },
]

export const archiverFolder = '000000000000000000000000';

export const undefinedEndDate = '4000-12-12T06:00:00.000Z';

export const nonEditableStatus = ['CANCELED'];

export default {
  googleAnalyticsTrackingId: "G-MR3ZMTSSDG",
  fbPixels: {
    register: '1119798455084076',
  },
  apiUrl: process.env[`REACT_APP${environment.toUpperCase()}_API_BASE_URL`] ?? 'http://localhost:4000',
  pusherApiKey: process.env[`REACT_APP${environment.toUpperCase()}_PUSHER_APP_KEY`],
  stripeApiKey: process.env[`REACT_APP${environment.toUpperCase()}_STRIPE_API_KEY`],
  baseUrl: process.env[`REACT_APP${environment.toUpperCase()}_BASE_URL`] ?? 'http://localhost:3000',
}
